import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import HistoryDetails from "@/shared/model/HistoryDetails";
import {computed} from "vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import {HistoryDetailsType} from "@/shared/model/HistoryDetailsType";
import HistoryDetailsString from "@/shared/model/HistoryDetailsString";
import HistoryDetailsOrderHeadInfo from "@/shared/model/HistoryDetailsOrderHeadInfo";
import HistoryDetailsOrderItemToInsuranceInfo from "@/shared/model/HistoryDetailsOrderItemToInsuranceInfo";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import SogButton from "@/shared/ui/SogButton.vue";
import {IdType} from "@/shared/model/idType";
import {useNavigationStore} from "@/modules/Navigation/store";
import HistoryDetailsIdString from "@/shared/model/HistoryDetailsIdString";

interface Props {
  details?: HistoryDetails
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HistoryListItemDetailsComponent',
  props: {
    details: { default: undefined }
  },
  setup(__props: any) {


const props = __props

const _navigationStore = useNavigationStore()


const _isOrderHead = computed(() => {
  if (props.details) {
    return props.details.getType() === HistoryDetailsType.OrderHeadInfo
  }
  return false
})

const _isString = computed(() => {
  if (props.details) {
    return props.details.getType() === HistoryDetailsType.String
  }
  return false
})

const _isIdString = computed(() => {
  if (props.details) {
    return props.details.getType() === HistoryDetailsType.IdString
  }
  return false
})


const _isOrderItemToInsurance = computed(() => {
  if (props.details) {
    return props.details.getType() === HistoryDetailsType.OrderItemToInsuranceInfo
  }
  return false
})

const _orderHead = computed<HistoryDetailsOrderHeadInfo>(() => {
  if (_isOrderHead.value)
    return props.details as HistoryDetailsOrderHeadInfo;
  return new HistoryDetailsOrderHeadInfo()
})

const _orderItemToInsurance = computed<HistoryDetailsOrderItemToInsuranceInfo>(() => {
  if (_isOrderItemToInsurance.value)
    return props.details as HistoryDetailsOrderItemToInsuranceInfo;
  return new HistoryDetailsOrderHeadInfo()
})


const _stringValue = computed(() => {
  if (_isString.value)
    return props.details as HistoryDetailsString;
  return new HistoryDetailsString()
})

const _idString = computed(() => {
  if (_isIdString.value)
    return props.details as HistoryDetailsIdString;
  return new HistoryDetailsIdString()
})

const _idType = computed(() => {
  if (_isIdString.value)
    ////  const t = (<any>IdType)[_idString.value.idType];

    return IdType[_idString.value.idType];
  return undefined
})

const _mdiIdType = computed(() => {
  switch (_idType.value) {
    case IdType.Insurance:
      return "mdi-shield";
    case IdType.VehicleRegistration:
      return "mdi-car";
    case IdType.InsuranceExportBlank:
      return "mdi-file-document";
  }
  return "mdi-information";
})

async function onOrderItemToInsuranceClick() {
  await _navigationStore.showObject(IdType.Order, _orderItemToInsurance.value.orderId ?? "");
}

async function onOrderHeadClick() {
  await _navigationStore.showObject(IdType.Order, _orderHead.value.id ?? "");
}

async function onIdStringClick() {
  await _navigationStore.showObject(_idType.value, _idString.value.id ?? "");
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: _orderHead.value.orderNumber
          }, null, 8, ["value"]),
          _createVNode(SogButton, {
            "mdi-icon": "mdi-information",
            "button-style": _unref(SogButtonStyle).Link,
            onClick: onOrderHeadClick
          }, null, 8, ["button-style"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: _orderHead.value.orderedDate,
            "value-type": _unref(SogDataLabelValueType).DateTime
          }, null, 8, ["value", "value-type"])
        ])
      ])
    ], 512), [
      [_vShow, _isOrderHead.value]
    ]),
    _withDirectives(_createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: _stringValue.value.value
          }, null, 8, ["value"])
        ])
      ])
    ], 512), [
      [_vShow, _isString.value]
    ]),
    _withDirectives(_createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: _idString.value.value
          }, null, 8, ["value"]),
          _createVNode(SogButton, {
            "mdi-icon": _mdiIdType.value,
            "button-style": _unref(SogButtonStyle).Link,
            onClick: onIdStringClick
          }, null, 8, ["mdi-icon", "button-style"])
        ])
      ])
    ], 512), [
      [_vShow, _isIdString.value]
    ]),
    _withDirectives(_createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: _orderItemToInsurance.value.orderNumber
          }, null, 8, ["value"]),
          _createVNode(SogButton, {
            "mdi-icon": "mdi-information",
            "button-style": _unref(SogButtonStyle).Link,
            onClick: onOrderItemToInsuranceClick
          }, null, 8, ["button-style"])
        ])
      ])
    ], 512), [
      [_vShow, _isOrderItemToInsurance.value]
    ])
  ]))
}
}

})